// CSS-data-URI form of `FilledArrowDown` for use as a `background-image` (e.g. on
// native <select> elements where the chevron position can't be controlled directly).
// Path matches `FilledArrowDown.jsx`.
//
// Uses double-quoted SVG attributes on purpose: encodeURIComponent leaves single
// quotes unescaped, which would terminate the outer `url('...')` wrapper. Double
// quotes encode to `%22` and are safe.
export const filledArrowDownDataUri = (color: string) =>
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"><path d="M12 16L6 10H18L12 16Z" fill="${color}"/></svg>`;
